export default __webpack_public_path__ + "static/media/Credit_Card_Icon_Circle.545bc029.svg";